export default {
    methods: {
        $tomorrowDate() {
            var today = new Date();
            var tomorrow = new Date();
            tomorrow.setDate(today.getDate()+1); 
            return tomorrow;
        },
        /*
        $validityCheck(context) {
            setInterval(() => {
                if (context.formstate.$invalid) {
                    context.requiredMsg = 'Remplissez les champs requis SVP';
                    context.disabled = true;
                } else {
                    context.requiredMsg = '';
                    context.disabled = false;
                }
            }, 1000)
        },*/
        $checkNull(value) {
            if (value === '' || value === false || value === null || value === 'undefined' || value === undefined) {
                return false;
            }
            return true;
        },
        $holidays(an) {
            var holidays = [];
            holidays.push(new Date(an, "00", "01"))
            holidays.push(new Date(an, "04", "01"))
            holidays.push(new Date(an, "04", "08"))
            holidays.push(new Date(an, "06", "14"))
            holidays.push(new Date(an, "07", "15"))
            holidays.push(new Date(an, "10", "01"))
            holidays.push(new Date(an, "10", "11"))
            holidays.push(new Date(an, "11", "25"))
            holidays.push(new Date(an, "11", "26"))

            var G = an % 19
            var C = Math.floor(an / 100)
            var H = (C - Math.floor(C / 4) - Math.floor((8 * C + 13) / 25) + 19 * G + 15) % 30
            var I = H - Math.floor(H / 28) * (1 - Math.floor(H / 28) * Math.floor(29 / (H + 1)) * Math.floor((21 - G) / 11))
            var J = (an * 1 + Math.floor(an / 4) + I + 2 - C + Math.floor(C / 4)) % 7
            var L = I - J
            var MoisPaques = 3 + Math.floor((L + 40) / 44)
            var JourPaques = L + 28 - 31 * Math.floor(MoisPaques / 4)
            holidays.push(new Date(an, MoisPaques - 1, JourPaques))
            holidays.push(new Date(an, MoisPaques - 1, JourPaques - 2))
            holidays.push(new Date(an, MoisPaques - 1, JourPaques + 1))
            holidays.push(new Date(an, MoisPaques - 1, JourPaques + 39))
            holidays.push(new Date(an, MoisPaques - 1, JourPaques + 49))
            holidays.push(new Date(an, MoisPaques - 1, JourPaques + 50))

            return holidays;
        },
        $CompareDateDMY(date1,  date2){
            var comp1 = new Date(date1.getFullYear() + "-" + (date1.getMonth() + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "-" + date1.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }));
            var comp2 = new Date(date2.getFullYear() + "-" + (date2.getMonth() + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "-" + date2.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }));
            if (comp1 >= comp2)
                return true;
            else
                return false;
        },
        
        $formatDateUs(date) {
            var startingDate = new Date(date);
            if (startingDate == 'Invalid Date') return;
            return startingDate.getFullYear() + "-" + (startingDate.getMonth() + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "-" + startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 });
        },
        $formatDateTimeFr(date) {
            //-- date must be US YYYY/MM/DD HH:MM
            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString('fr-fr', { month: 'short' });
            var day = startingDate.toLocaleString('fr-fr', { weekday: 'short' });
            var dayInt = startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 });
            var hours = startingDate.getHours().toLocaleString(undefined, { minimumIntegerDigits: 2 });
            var minutes = startingDate.getMinutes().toLocaleString(undefined, { minimumIntegerDigits: 2 });

            return day + ' ' + dayInt + ' ' + month + ' ' + startingDate.getFullYear() + ' ' + hours + ':' + minutes;
        },
        $formatDateFr(date, noWeekDay = false) {
            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString("fr-fr", { month: "short" });
            var day = (noWeekDay) ? startingDate.toLocaleString("fr-fr", { weekday: "short" }) : '';
            return day + " " + startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }) + " " + month + " " + startingDate.getFullYear();
        },
        $processExecMsg(data) {
            if (!this.$checkNull(data))
                this.$Notification.error(data.replace(/<[^>]+>/g, ''));
            else
                if (this.$checkNull(data.result)) {
                    const code = data.result.code;
                    const msg = data.result.msg;

                    if (code == '100')
                    {
                        this.$Notification.success(`${msg}`);
                        return true;
                    }
                    else
                        this.$Notification.warn(`${msg}`);
                } else {
                    //-- No return formated, displaying raw result | removing html
                    this.$Notification.error(data.replace(/<[^>]+>/g, ''));
                }
            
            return false;
        },
        $processDataMsg(data) {
            if (this.$checkNull(data.code)) {
                //this.$Notification.warn(`Code: ${data.code} || Msg: ${data.msg}`)
                this.$Notification.warn(`${data.msg}`)
                return false;
            }
            else
                return true;
        },

        $hexToRgb(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },
        $existValueArrays(tab1, tab2) {
            if (!Array.isArray(tab1)) return false;
            if (!Array.isArray(tab2)) tab2 = [tab2];
            var rs = false;
            if (this.$checkNull(tab1)) {
                for (var i = 0; i < tab1.length; i++) {
                    if (this.$checkNull(tab2))
                        tab2.forEach((item) => {
                            if (tab1[i] == item)
                                rs = true;
                        });
                    if (rs) return true;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/helpers.js